import Footer from "../Homepages/Footer";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { BiFolderPlus } from "react-icons/bi";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { blessing } from "../../reducers/userReducer";

export default function EnterGrat() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let date = new Date();
  let newDate = date.toDateString();
  const time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  const [blessings, setBlessings] = useState("");
  const onSubmit = (e) => {
    e.preventDefault();
    if(blessings.length>0){
      dispatch(blessing({gratitude:blessings, date:newDate, time}));
    }
    navigate('/gratitudes')
  };
  return (
    <div className="container px-4 px-md-5">
      <div className="heading mb-5 mt-5">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate('/gratitude');
          }}
        />
        <h3 className="text-center no-wrap">Count my blessings</h3>
      </div>
      <div className="container px-md-5">
        {newDate}
        <div className="d-flex justify-content-between align-items-center">
          <h2>Today I am grateful for...</h2>
          <BiFolderPlus size="30px" />
        </div>
        <form
          className="form"
          onSubmit={(e) => {
            onSubmit(e);
          }}
        >
          <textarea
            className="form-control textarea my-4"
            rows="8"
            placeholder="Enter your blessings"
            value={blessings}
            onChange={(e) => {
              setBlessings(e.target.value);
            }}
          ></textarea>
          <button className="btnSave" type="submit">
            Save
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
